import {
  REGISTER_SUCCESS,
  REGISTER_FAIL,
  USER_LOADED,
  AUTH_ERROR,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT,
  CLEAR_PROFILE,
  INCREMENT_SOCIAL_CLICK,
  SESSION_EXPIRED,
  SESSION_CLEARED,
} from '../actions/types';

const initialState = {
  token: localStorage.getItem('token'),
  isAuth: false,
  user: null,
  // Set when the server says the session is over. Deliberately its own
  // field rather than a flavour of AUTH_ERROR: see the case below.
  sessionExpired: null,
  loading: true,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case USER_LOADED:
      return {
        ...state,
        isAuth: true,
        user: payload,
        loading: false,
      };

    case INCREMENT_SOCIAL_CLICK:
      if (!state.user || !state.user.social || !state.user.social[payload.name]) {
        return state;
      }
      return {
        ...state,
        user: {
          ...state.user,
          social: {
            ...state.user.social,
            [payload.name]: {
              ...state.user.social[payload.name],
              clicks: (state.user.social[payload.name].clicks || 0) + 1,
            },
          },
          // Dashboard.js now renders from socialList (Phase 3b step 3),
          // not social -- mirrored here too so the optimistic click
          // count still bumps immediately instead of going stale until
          // the next GET /api/auth/current. No-op (via the unchanged
          // .map()) if socialList isn't present yet or has no entry for
          // this platform, same "do nothing" shape as the guard above.
          socialList: (state.user.socialList || []).map((entry) =>
            entry.platform === payload.name
              ? { ...entry, clicks: (entry.clicks || 0) + 1 }
              : entry
          ),
        },
      };

    case REGISTER_SUCCESS:
    case LOGIN_SUCCESS:
      localStorage.setItem('token', payload.token);
      return {
        ...state,
        ...payload,
        isAuth: true,
        loading: false,
      };
    case REGISTER_FAIL:
    // The session ended -- an expired token, or one predating a password
    // change. Emphatically NOT handled as AUTH_ERROR: that clears isAuth,
    // and every editing screen redirects on !isAuth, so the customer's
    // unsaved work would be unmounted the instant their session lapsed.
    // The token is left in place too; it is dead either way, and removing
    // it changes nothing except making the redirect happen.
    //
    // What ends the session in the UI is the customer choosing to sign in
    // again (SESSION_CLEARED below), by which point they have had the
    // chance to keep what they were doing.
    case SESSION_EXPIRED:
      return {
        ...state,
        // loading is resolved so the app renders. isAuth is deliberately
        // untouched: false stays false on a cold load (and the visitor is
        // sent to sign in, correctly), true stays true mid-session so the
        // screen they are editing is not torn down underneath them.
        loading: false,
        sessionExpired: payload && payload.msg ? payload.msg : 'Your session has ended.',
      };
    case SESSION_CLEARED:
      localStorage.removeItem('token');
      return {
        ...state,
        user: null,
        token: null,
        isAuth: false,
        sessionExpired: null,
        loading: false,
      };
    case AUTH_ERROR:
    case LOGIN_FAIL:
    case LOGOUT:
    case CLEAR_PROFILE:
      localStorage.removeItem('token');
      return {
        ...state,
        user: null,
        token: null,
        isAuth: false,
        loading: false,
      };
    default:
      return state;
  }
}
